import { AbstractControl, ValidatorFn } from '@angular/forms';

export function singleFileExtensionValidator(extension: string | string[]): ValidatorFn {
	return (control: AbstractControl) => {
		const fileName = control.value;
		if (!fileName) {
			return null;
		}
		if (typeof extension === 'string') {
			extension = [extension];
		}
		extension = extension.map(ext => (ext.charAt(0) === '.' ? ext.substring(1) : ext));

		const fileExtension = fileName.split('.').pop();
		if (!fileExtension) {
			return { fileExtension: true };
		}

		const extensionIsAllowed = extension.findIndex(extension => extension === fileExtension) >= 0;

		return extensionIsAllowed ? null : { fileExtension: true };
	};
}
